import { c as _c } from "react/compiler-runtime";
import Svg, { type SvgProps } from '../../Svg';

/**
 * Info Right Icon from Figma
 * @link [Figma](https://www.figma.com/design/bUeKiC8YcV9PHrMlJAZUJG/Design-System?node-id=1010-23781&m=dev)
 * */

const InfoIcon = props => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g clipPath="url(#clip0_1332_8130)" stroke="stroke-current"><path d="M6 3a.187.187 0 110 .375M6 3a.187.187 0 100 .375" /><path d="M6 5.25V9" strokeMiterlimit={10} strokeLinecap="round" /><path d="M.5 6a5.5 5.5 0 1011 0 5.5 5.5 0 00-11 0z" strokeLinecap="round" strokeLinejoin="round" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <defs><clipPath id="clip0_1332_8130"><path fill="#fff" d="M0 0H12V12H0z" /></clipPath></defs>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props) {
    t2 = <Svg width={12} height={12} {...props}>{t0}{t1}</Svg>;
    $[2] = props;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default InfoIcon;